import { useGetInvoiceCountV1, useGetLitigeCountV1 } from "@/api/invoice";
import { DisplayType } from "@/types/invoiceDisplayTypes";
import { InvoiceStatusEnum } from "@/constants/enums/invoiceStatus.enum";
import { useInvoiceDisplayTypeOptions } from "@/hooks/useEnumOptions";

type DisplayTypeSelectProps = {
  setDisplayType: React.Dispatch<React.SetStateAction<DisplayType>>;
  displayType: DisplayType;
  counter: boolean;
};

export const DisplayTypeSelectBo = ({
  setDisplayType,
  displayType,
  counter = false,
}: DisplayTypeSelectProps) => {
  const displayTypesOptions = useInvoiceDisplayTypeOptions();
  const { data: litigesCount } = useGetLitigeCountV1({
    paymentStatus: "TOBEPAID",
    status: [InvoiceStatusEnum.VALIDATED, InvoiceStatusEnum.PENDING, InvoiceStatusEnum.BLOCKED],
  });
  const { data: invoicesCount } = useGetInvoiceCountV1({
    paymentStatus: "TOBEPAID",
    status: [InvoiceStatusEnum.VALIDATED, InvoiceStatusEnum.BLOCKED],
  });
  const { data: blockedInvoicesCount } = useGetInvoiceCountV1({
    status: [InvoiceStatusEnum.BLOCKED],
  });
  const { data: invoicesToBeValidatedCount } = useGetInvoiceCountV1({
    status: [InvoiceStatusEnum.PENDING],
  });

  const getCount = (displayTypeOption: string) => {
    if (displayTypeOption === "invoiceToBeValidated") {
      return invoicesToBeValidatedCount || 0;
    }
    if (displayTypeOption === "invoice") {
      return invoicesCount || 0;
    }
    if (displayTypeOption === "litige") {
      return litigesCount || 0;
    }
    if (displayTypeOption === "invoiceBlocked") {
      return blockedInvoicesCount || 0;
    }
    return 0;
  };

  return (
    <div className="flex w-fit flex-row rounded-lg border border-gray-200 bg-white p-0.5">
      {displayTypesOptions.map((displayTypeOption) => {
        return (
          <button
            key={displayTypeOption.value}
            className={`flex flex-row items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-gray-700 focus:outline-hidden ${displayType === displayTypeOption.value ? "bg-brand700 text-white" : "bg-transparent text-gray-700 hover:text-gray-900"}`}
            onClick={() => setDisplayType(displayTypeOption.value as DisplayType)}
          >
            <span>{displayTypeOption.label}</span>
            {counter && (
              <div
                className={`flex h-4 w-4 items-center justify-center rounded-full bg-red-700 p-3 text-white`}
              >
                {getCount(displayTypeOption.value)}
              </div>
            )}
          </button>
        );
      })}
    </div>
  );
};
